import { useMemo} from 'react';
import { Form, Input, Button, Row, Col, Image, Layout} from 'antd';
import { useLocation } from 'react-router-dom';
import { useMutation } from 'react-query';
import MainHeader from '../../components/MainLayout/MainHeader';
import MyCard from '../../components/MyCard/MyCard';
import { useAuthContext } from '../../shared/context/auth-context';
import useHttpClient from '../../shared/sendRequest/useHttpClient'
import  EndPoints from '../../shared/endPoints/EndPoints.json';
import btmLogo from '../../assets/btm logo.png'

export default function LoginImpersonate() {
    const { login } = useAuthContext();
    const { sendRequest } = useHttpClient();
    const { search } = useLocation();
    const searchParams =  useMemo(() => new URLSearchParams(search), [search]);
    const userId = searchParams.get('userId')
    const [form] = Form.useForm();
    const {mutate } = useMutation(sendRequest, {
         onSuccess: (data) => {
            if (data?.accessToken) login(data?.accessToken, false)
            form.resetFields();
        },
    });

    const { Header } = Layout;

    const layout = {
        labelCol: {
            span: 11,
        },
        wrapperCol: {
            span: 16,
        },
    };

    const onFinish = (loginCompanyData) => {
        mutate({
          endpoint: EndPoints.USER.IMPERSONATECLIENT,
          method: 'POST',
          bodyData: { ...loginCompanyData, userId }
        });
    }

    return (
        <>
            <Header style={{ backgroundColor: '#fff', position: 'fixed', width: '100% ', zIndex: 9999 ,top:0}}  >
                <MainHeader headerMenuRender={false} />
            </Header>
            <Row align="middle" style={{ minHeight: '100vh', minWidth: "100vw", backgroundColor: '#F0F0F0' }}>
                <Col xs={24} sm={24} md={24} lg={{ span: 8, push: 7 }} >
                    <Row >
                        <Col xs = {12} md={{span: 12 , offset: 3}} ><Image src={btmLogo} preview={false} width={340}  /></Col>
                        <Col span={24}> <MyCard title="Impersonate User" >
                            <Col>
                                <Form
                                    {...layout}
                                    name="basic"
                                    form={form}
                                    onFinish={onFinish}
                                    initialValues={{
                                        remember: true,
                                    }}
                                >
                                    <Form.Item
                                        label="Όνομα Χρήστη"
                                        name="username"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Παρακαλώ τοποθετήστε το Όνομα Χρήστη',
                                            },
                                        ]}
                                        
                                    >
                                        <Input />
                                    </Form.Item> 
                                    <Form.Item
                                        label="Κωδικός Πρόσβασης:"
                                        name="password"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Παρακαλώ τοποθετήστε τον Κωδικό Πρόσβασης',
                                            },
                                        ]}
                                    >
                                        <Input.Password />
                                    </Form.Item>
                                    <Form.Item>
                                        <Row justify='center'>
                                            <Button htmlType="submit" style={{ backgroundColor: 'black', color: 'white', borderRadius: 20 }}>
                                                Προσομοίωση
                                            </Button>
                                        </Row>
                                    </Form.Item>
                                </Form>
                            </Col>
                        </MyCard></Col>
                    </Row>
                </Col>
            </Row>
        </>
    )
}